export default __webpack_public_path__ + "static/media/15_1.d48991bd.jpg";